import { render, staticRenderFns } from "./ManageFeatureUpdates.vue?vue&type=template&id=0ebd3790&"
import script from "./ManageFeatureUpdates.vue?vue&type=script&lang=js&"
export * from "./ManageFeatureUpdates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports